import { AnalyticsWindow } from "../window"
import { handleHubspotFormReady, handleHubspotFormSubmit } from "../hubspot"
import { sendPersistedSegmentFormSubmittedEvent } from "../send-persisted-form-submitted-event"
import { sendPersistedSegmentTraits } from "../send-persisted-segment-traits"

declare let window: AnalyticsWindow

export default function analyticsGlobalEvents(
  _el: HTMLElement,
  _props: object,
) {
  if (!window.analytics) return

  window.addEventListener("message", event => {
    // Hubspot form callbacks. See: https://legacydocs.hubspot.com/global-form-events
    if (event.data.type === "hsFormCallback") {
      // This onFormSubmit event fires when Hubspot forms have been inserted
      // into the DOM.
      if (event.data.eventName === "onFormReady") {
        handleHubspotFormReady(event)
      }

      // This onFormSubmit event fires when Hubspot forms are about to be
      // submitted to Hubspot.
      //
      // This cannot be used to pause form submission while waiting for Segment
      // events to be recorded. Thus, we instead persist information for Segment
      // identify and track event calls to local storage, where it's available
      // for the page the form redirects to to send to Segment on the subsequent
      // page view. This will not work for any forms that render a thank you in
      // line, rather than redirecting, but at the moment our Hubspot forms do
      // redirect.
      //
      // One alternative measure is to introduce jQuery, so that we can use
      // callbacks provided by the hubspot JS, which lamely demand jQuery be
      // present even though the hubspot JS is written in React.
      if (event.data.eventName === "onFormSubmit") {
        handleHubspotFormSubmit(event)
      }
    }
  })

  // Send any Segment track or identify calls persisted by the previous page
  sendPersistedSegmentFormSubmittedEvent()
  sendPersistedSegmentTraits()
}
